
<script setup>

</script>

<template>
  <div class="cmp-grid-function-tips_wrapper">
    <div style="font-size: 14px;">Grid Functionality</div>
    <span style="font-size: 11px;">(If the grid menu is disabled the configuration of the columns will not be saved)</span>
    <ul>
      <li>
        If enabled, use the menu to disable / enable columns.
      </li>
      <li>
        Drag columns from the heading to re-order them.
      </li>
      <li>
        Resize columns by right clicking on the headings (auto saves when you move away).
      </li>
      <li>
        Right click on data cells to copy the value to clipboard.
      </li>
      <li>
        Left click highlights the current row to spotlight the record for added focus.
      </li>
    </ul>
  </div>

</template>

<style lang="scss" scoped>

ul li {
  margin-bottom: 4px;
}

.cmp-grid-function-tips {

  &_wrapper {
    height: 120px;
    width: 500px;
    padding: 10px;
  }
}

</style>
